import type { FunctionComponent } from 'react'

import { useFlowCleanupOnLeave } from '#hooks'

import { EndOfFlowNotice } from './Components/EndOfFlowNotice'
import { IndicationOfResult } from './Components/IndicationOfResult'
import { MonthioFinishedScreen } from './Components/MonthioFinishedScreen'
import { useFlowCompletedModule } from './useFlowCompletedModule'

export const FlowCompleted: FunctionComponent = () => {
	const { data, config } = useFlowCompletedModule()

	useFlowCleanupOnLeave()

	const { redirectUrl } = data
	const hasRedirectUrl = redirectUrl != null
	const isEnabledAutoCloseTabOnFlowCompletion =
		data.shouldAutoCloseTabOnFlowCompletion

	if (isEnabledAutoCloseTabOnFlowCompletion || hasRedirectUrl) {
		return (
			<EndOfFlowNotice
				redirectUrl={redirectUrl}
				redirectUrlNoQueryParams={data.redirectUrlNoQueryParams}
				shouldRedirectWithoutDelay={data.shouldRedirectWithoutDelay}
				shouldAutoCloseTabWithoutDelay={data.shouldAutoCloseTabWithoutDelay}
			/>
		)
	}

	if (data.shouldShowIndicationOfResult && config.isFinalFlow) {
		return <IndicationOfResult />
	}

	return <MonthioFinishedScreen />
}
